window.BrewyCollection = (function () {
  function initFilters(root) {
    var buttons = root.querySelectorAll('.brewy-filter-btn');
    var cards = root.querySelectorAll('.brewy-card');
    var noResults = root.querySelector('.brewy-no-results');

    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (button) {
          button.classList.remove('is-active');
          button.setAttribute('aria-selected', 'false');
        });

        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');

        var tag = (
          btn.getAttribute('data-filter-tag') || 'all'
        ).toLowerCase();

        var visibleCount = 0;

        cards.forEach(function (card) {
          var cardTags = (
            card.getAttribute('data-tags') || ''
          ).toLowerCase();

          var matches =
            tag === 'all' ||
            cardTags.indexOf(tag + ',') !== -1;

          card.hidden = !matches;

          if (matches) {
            visibleCount++;
          }
        });

        if (noResults) {
          noResults.classList.toggle(
            'is-visible',
            visibleCount === 0
          );
        }
      });
    });
  }

  function init(sectionId) {
    var root = document.getElementById(sectionId);

    if (!root) return;

    initFilters(root);
  }

  return {
    init: init
  };
})();